import {immerable} from 'immer';

export type Page = 'landing' | 'howItWorks' | 'login' | 'signup' | 'home' | 'account' | 'legal';

export class NavigationStoreModel {
    [immerable] = true;

    currentPage: Page = 'landing';

    onPageActivated(page: Page): void {
        this.currentPage = page;
    }
}
